var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c(
      "div",
      { staticClass: "boss-main-wrap boss-main-content-wrap" },
      [
        _c("setting-header", {
          attrs: {
            breadcrumbs: [
              { name: "各種設定" },
              { name: "アカウント管理", pathName: "settingAccounts" },
            ],
            title: "アカウント" + _vm.formTypeLabel,
            "data-test": "title",
          },
        }),
        _vm._v(" "),
        _c("p", [_vm._v("下記の項目を入力してください。")]),
        _vm._v(" "),
        _c("form-item", {
          attrs: { "form-label-class-name": "pega-form-label-account" },
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function () {
                return [
                  _vm._v("\n        氏名\n        "),
                  _c("small", [_vm._v("(25文字以内)")]),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.staffName,
            callback: function ($$v) {
              _vm.staffName = $$v
            },
            expression: "staffName",
          },
        }),
        _vm._v(" "),
        _c("form-item", {
          attrs: { "form-label-class-name": "pega-form-label-account" },
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function () {
                return [
                  _vm._v("\n        TEL\n        "),
                  _c("small", [_vm._v("(任意：50文字以内)")]),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.tel,
            callback: function ($$v) {
              _vm.tel = $$v
            },
            expression: "tel",
          },
        }),
        _vm._v(" "),
        _c("form-item", {
          attrs: {
            label: "メールアドレス",
            "form-label-class-name": "pega-form-label-account",
          },
          model: {
            value: _vm.email,
            callback: function ($$v) {
              _vm.email = $$v
            },
            expression: "email",
          },
        }),
        _vm._v(" "),
        _c("form-item", {
          attrs: {
            value: _vm.loginIdLabel,
            label: "ログインID",
            tag: "label",
            type: "",
            "form-label-class-name": "pega-form-label-account",
          },
        }),
        _vm._v(" "),
        _c("form-item", {
          attrs: {
            "class-name": _vm.isLengthValidationAuthentication
              ? "is-invalid-input certification-number-length"
              : "certification-number-length",
            "data-test": "authentication-invalid",
            "form-label-class-name": "pega-form-label-account",
          },
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function () {
                return [
                  _vm._v("\n        認証番号\n        "),
                  _c("small", [_vm._v(_vm._s(_vm.authenticationValidLabel))]),
                ]
              },
              proxy: true,
            },
            {
              key: "error",
              fn: function () {
                return [
                  _vm._l(_vm.authenticationValidationList, function (error, i) {
                    return [
                      error.isShow
                        ? _c("validation-label", {
                            key: i,
                            attrs: {
                              "data-test": "error-" + i,
                              label: error.message,
                            },
                          })
                        : _vm._e(),
                    ]
                  }),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.authentication,
            callback: function ($$v) {
              _vm.authentication = $$v
            },
            expression: "authentication",
          },
        }),
        _vm._v(" "),
        _c("form-item-group", {
          attrs: {
            disabled: !_vm.isGeneral,
            options: _vm.permissionOptions,
            "form-label-class-name": "pega-form-label-account",
          },
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function () {
                return [
                  _vm._v("\n        操作権限\n        "),
                  _c("small", [_vm._v("(任意)")]),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.permissions,
            callback: function ($$v) {
              _vm.permissions = $$v
            },
            expression: "permissions",
          },
        }),
        _vm._v(" "),
        _c("form-item-group", {
          attrs: {
            disabled: _vm.checkId,
            options: _vm.receivableMailTypeOptions,
            "form-label-class-name": "pega-form-label-account",
            "mail-flag": _vm.checkId,
          },
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function () {
                return [
                  _vm._v("\n        メール受信設定 \n        "),
                  _c("small", [_vm._v("(任意)")]),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.receivableMailTypes,
            callback: function ($$v) {
              _vm.receivableMailTypes = $$v
            },
            expression: "receivableMailTypes",
          },
        }),
        _vm._v(" "),
        _c(
          "form-button-area",
          [
            _c("form-confirm-button", {
              attrs: {
                "button-class": "pega-width-auto",
                "is-disabled": _vm.isDisabled,
                "submit-label": _vm.submitLabel,
                "data-test": "confirm-button",
              },
              on: { "submit-event": _vm.onRegisterClick },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }